module.exports = __webpack_public_path__ + "img/cat_03.a5299753.jpg";